import { combineReducers } from 'redux';

import categoriesReducer from 'store/reducers/categoriesReducer/categoriesReducer';
import listsReducer from 'store/reducers/listsReducer';
import messagesReducer from 'store/reducers/messagesReducer/messagesReducer';
import settingsReducer from 'store/reducers/settingsReducer/settingsReducer';
import userReducer from 'store/reducers/userReducer/userReducer';

export default combineReducers({
  user: userReducer,
  lists: listsReducer,
  settings: settingsReducer,
  messages: messagesReducer,
  categories: categoriesReducer,
});
